import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface DateChangeWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
}

export function DateChangeWarningDialog({
  open,
  onOpenChange,
  onClose,
}: DateChangeWarningDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="mb-2 flex items-center gap-3">
            <div className="rounded-full bg-destructive/20 p-2">
              <AlertTriangle className="h-5 w-5 text-destructive" />
            </div>
            <AlertDialogTitle>Date changes not allowed</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3">
            <p>
              Changing dates after creating schedules or crew assignments isn't possible, as this
              would break core data relationships.
            </p>
            <p className="text-sm">
              Please create a new production with the correct dates instead.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>Understood</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
